module.exports = __webpack_public_path__ + "img/20.16bc0906.jpg";